import { inject } from '@angular/core';
import type { Route } from '@angular/router';
import { bonusesLandingUrl } from '../../../../core/auth/worknest-admin-permissions';
import { permissionGuard } from '../../../../core/guards/permission.guard';
import { PermissionService } from '../../../../core/services/permission.service';

/**
 * Bonus & profit share (`/bonuses`). Every page is re-checked on in-area navigation too: the admin shell's
 * `permissionGuard` runs only when the shell itself is entered (the Benefits rule). `bonusesAreaPermissions` gives each
 * tab its own group; the bare area lands on the first tab the caller may open.
 */
export const BONUSES_ROUTE: Route = {
  path: 'bonuses',
  children: [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: () => {
        const permissions = inject(PermissionService);
        return bonusesLandingUrl((anyOf) => permissions.hasAny(anyOf));
      },
    },
    {
      path: 'runs',
      canActivate: [permissionGuard],
      loadComponent: () => import('./runs/runs-page.component').then((m) => m.RunsPageComponent),
    },
    {
      path: 'runs/new',
      canActivate: [permissionGuard],
      loadComponent: () => import('./runs/run-editor-page.component').then((m) => m.RunEditorPageComponent),
    },
    {
      path: 'runs/:id',
      canActivate: [permissionGuard],
      loadComponent: () => import('./runs/run-editor-page.component').then((m) => m.RunEditorPageComponent),
    },
    {
      path: 'awards',
      canActivate: [permissionGuard],
      loadComponent: () => import('./awards/awards-page.component').then((m) => m.AwardsPageComponent),
    },
  ],
};
